// extracted by mini-css-extract-plugin
module.exports = {"office":"styles_office__3aixa","pulse":"styles_pulse__Ichx8","jump":"styles_jump__frztJ"};